import type { ComponentProps, ReactNode } from 'react'
import type { LoyaltyEligibleOfferOrProperty } from 'loyalty/lib/esims/esimOfferEligibility'
import useLoyaltyBenefitInclusions from 'loyalty/hooks/useLoyaltyBenefitInclusions'
import SearchTileRowInclusionItem from 'components/SearchKit/SearchTiles/shared/SearchTileRowInclusionItem'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LoyaltyBenefitInfoIcon from 'loyalty/components/LoyaltyBenefitInfoIcon'

type InheritedOfferInclusionItemProps = Pick<ComponentProps<typeof OfferInclusionItem>, 'size' | 'iconSize'>

interface Props extends InheritedOfferInclusionItemProps {
  offer?: LoyaltyEligibleOfferOrProperty
  variation?: App.Tours.TourV2OfferVariation
  /** Pre-computed inclusions; when provided, skips the internal eligibility hook. */
  inclusions?: Array<App.OfferInclusion>
  variant?: 'search-tile' | 'offer-page'
  children?: (inclusions: Array<App.OfferInclusion>) => ReactNode
}

function LoyaltyInclusions({ offer, variation, inclusions, variant, size, iconSize, children }: Props) {
  const defaultInclusions = useLoyaltyBenefitInclusions(offer, variation)
  const renderedInclusions = inclusions ?? defaultInclusions

  if (!renderedInclusions.length) {
    return null
  }

  if (children) {
    return <>{children(renderedInclusions)}</>
  }

  if (variant === 'search-tile') {
    return <>
      {renderedInclusions.map((inclusion) => <SearchTileRowInclusionItem
        key={inclusion.id}
        inclusion={inclusion}
        endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
      />)}
    </>
  }

  if (variant === 'offer-page') {
    return <>
      {renderedInclusions.map((inclusion) => <OfferInclusionItem
        key={inclusion.id}
        inclusion={inclusion}
        size={size}
        iconSize={iconSize}
        endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
      />)}
    </>
  }

  return null
}

export default LoyaltyInclusions
